export default __webpack_public_path__ + "static/media/kitchen1-1920w.d8515dc0.avif";